import { atom } from 'jotai'
import { subscribeBroadcast } from '@highlight/ipc'
import { AUDIO_LEVELS_TOPIC, type AudioLevelsSnapshot } from '@shared/audio-levels'

const NO_AUDIO_THRESHOLD = 1
const NO_AUDIO_DELAY_MS = 3000

export const noAudioAtom = atom(false)

noAudioAtom.onMount = (setNoAudio) => {
  const broadcastApi = typeof window !== 'undefined' ? window.ipc?.broadcast : null
  if (!broadcastApi) {
    return
  }

  let noAudioTimer: ReturnType<typeof setTimeout> | null = null

  const unsubscribe = subscribeBroadcast<AudioLevelsSnapshot>(AUDIO_LEVELS_TOPIC, ({ input }) => {
    if (input < NO_AUDIO_THRESHOLD) {
      if (!noAudioTimer) {
        noAudioTimer = setTimeout(() => {
          noAudioTimer = null
          setNoAudio(true)
        }, NO_AUDIO_DELAY_MS)
      }
      return
    }

    if (noAudioTimer) {
      clearTimeout(noAudioTimer)
      noAudioTimer = null
    }
    setNoAudio(false)
  })

  return () => {
    if (noAudioTimer) {
      clearTimeout(noAudioTimer)
    }
    unsubscribe()
  }
}
